// @ts-nocheck
import React, { useState, useEffect } from "react";
import axios from "axios";
import Box from '@mui/material/Box';
import Typography from "@mui/material/Typography";
import { SIZE_MD, URL_API_SIA } from "../Contantes/Constantes";
import { setupInterceptorsTo } from "../Componentes/API/AxiosBuilder";
import Grid from '@mui/material/Grid';
import makeStyles from '@mui/styles/makeStyles';
import { TreeViewAreas } from './Componentes/TreeViewAreas'
import CircularProgress from "@mui/material/CircularProgress";
import { DialogContent as ModalContent } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useAreas } from "./State/AreasContext";
import FormInput from "../Componentes/FormInput";
import FormInputMultiline from "../Componentes/FormInputMultiline";
import { TextFieldRojo } from "../App";
import { IconButton, InputAdornment } from "@mui/material";
import { CloseButton } from "../Componentes/feedback/dialog/CloseButton";
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { BotonVerde } from "../Difusiones/Componentes/BotonVerde";
import Joi from "joi";
import { Edit as EditIcon } from '@mui/icons-material';
import Tooltip from '@mui/material/Tooltip';
import SinapTheme from "../styles/SinapTheme";
import { styled } from '@mui/material/styles';
import { Check, Cruz } from "../Componentes/Icons";
import Input from '@mui/material/Input';
import { Form } from "../Componentes/useForm";
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { useBody } from "../Body/state/BodyContext";
import { SaveButton } from "../Componentes/inputs/SaveButton";
import { DialogActions as ModalActions } from '@mui/material';
import Zoom from '@mui/material/Zoom';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import AlertMessage from "../Alias/AlertMessage";
import ConfirmarNoReplyDuplicado from "./Componentes/ConfirmarNoReplyDuplicado";
import CamposNoReply from "./Componentes/CamposNoReply";

const useStyles = makeStyles(theme => ({
    iconos: {
        display: 'flex',
        justifyContent: 'flex-end',
        position: 'fixed',
        right: "32px",
    },
    typografy: {
        width: "100%",
        padding: "3%",
        color: SinapTheme.palette.primary.main,
    },
    text: {
        fontsize: '20%',
        marginLeft: '10%',
    },
    input: {
        margin: '2%'
    },
    select: {
        margin: '1%',
        width: '100%'
    },
    texto: {
        '@media (max-width: 900px)': {
            fontSize: '80%',
        },
    },
}))

const Div = styled('div')(({ theme }) => ({
    color: SinapTheme.palette.primary.main,
    width: '80%'
}));

const styleLista = {
    width: '80%',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
}

export const EditarAreas = ({ onClose, grupo, areas, handleUpdate, ...props }) => {
    const { areaData, areaSub, fetchArea, fetchSubgrupos, getAreas, loading, setLoading, value, setValue, getAreasTree, areasTreeFlatList,
        handleChangeI, handleChangeO, handleChangeTN, handleChangeTD,
        handleClickRemoveIntegrante, handleClickAddIntegrante,
        handleClickRemoveOficina, handleClickAddOficina,
        handleClickRemoveInterno, handleClickAddInterno,
        integrantes, setIntegrantes,
        oficina, setOficina, area, setArea,
        numero, setNumero,
        especificacion, setEspecificacion,
        alertOficina, setAlertOficina,
        alertInterno, setAlertInterno, } = useAreas()
    const classes = useStyles();
    const { setSuccess, setMessage } = useBody();
    const [errores, setErrores] = useState([]);
    const [conflictoNoReply, setConflictoNoReply] = useState(null);
    const [disabled, setDisabled] = useState(true);
    const [disabledSaveButton, setDisabledSaveButton] = useState(false);
    const matches = useMediaQuery('(max-width:600px)');
    const [nombreAux, setNombreAux] = useState(grupo.nombre);
    const axiosInstance = setupInterceptorsTo(axios.create());

    async function fechInfo() {
        setLoading(true);
        await fetchArea(grupo);
        await fetchSubgrupos(grupo);
        await getAreasTree();
        setLoading(false);
    }

    useEffect(() => {
        fechInfo();
    }, [])

    const handleSubmit = async (e) => {
        setLoading(true);
        e.preventDefault();
        if (integrantes !== '') { setMessage('Debe pulsar el + para guardar el integrante'); setLoading(false); return; }
        else if (oficina !== '') { setMessage('Debe pulsar el + para guardar el numero de oficina'); setLoading(false); return; }
        else if (numero !== '') { setMessage('Debe pulsar el + para guardar el interno '); setLoading(false); return; }
        else if (especificacion !== '') { setMessage('Debe pulsar el + para guardar el interno'); setLoading(false); return; }
        if (nombreAux.includes('/')) { setMessage('El nombre no puede contener el carácter "/"'); setLoading(false); return; }
        let error = validateForm();
        if (error) {
            mensajeAlertaFalloFormulario(error);
            setLoading(false);
            return;
        }
        let inter = area.internos.filter((i) => { return i.numero !== '' })
            .map((i) => {
                return 'numero:' + i.numero + ';especificacion:' + i.especificacion;
            })

        let body = {
            id: grupo.id,
            path: area.path === '/' ? area.path + nombreAux : area.path + '/' + nombreAux,
            nombre: nombreAux,
            integrantes: area.integrantes,
            observaciones: area.observaciones,
            internos: inter,
            oficinas: area.oficinas.filter((o) => { return o !== '' }),
            noReply: area.noReply ?? [],
        }
        editarArea(body);
    }

    const editarArea = (body, confirmarDuplicado = false) => {
        setLoading(true);
        axiosInstance({
            method: 'PUT',
            url: URL_API_SIA + "/areas/area",
            data: { ...body, confirmarDuplicado }
        })
            .then(() => {
                setSuccess("El área fue editada correctamente!");
                setConflictoNoReply(null);
                setLoading(false);
                onClose();
                handleUpdate();
            }).catch(err => {
                setLoading(false);
                if (err.response?.data?.status === "noReplyDuplicado") {
                    setConflictoNoReply({ ...err.response.data, body });
                } else if (err.response?.data?.status === "Hay integrantes que no existen") {
                    setMessage("Hay UIDs que no existen. No se pudo editar el área.")
                    setErrores(err.response.data.uids)
                } else {
                    setMessage({ status: "error", message: "No se pudo editar el área." })
                }
            })
    }

    function validateForm() {
        let validation = validationSchema.validate(area);
        if (validation.error) {
            let campo = validation.error.details[0].path[0];
            if (campo === 'internos') {
                if (validation.error.details[0].type === 'any.required') {
                    return 'Numero requerido';
                }
                return validation.error.message
            } else {
                return validation.error.details[0].path[0]
            }
        };

    }

    const validationSchema = Joi.object({
        path: Joi.string().min(1).max(1000).required(),
        nombre: Joi.string().min(3).max(150).required(),
        integrantes: Joi.array().items(
            Joi.object({
                id: Joi.string().allow('').optional(),
                username: Joi.string().min(3).max(70).required().messages({
                    'string.min': 'El username debe tener al menos 3 caracteres',
                    'string.max': 'El username no puede exceder 70 caracteres',
                    'any.required': 'El username es obligatorio'
                }),
                nombre_completo: Joi.string().allow('').optional(),
                mail: Joi.string().allow('').optional()
            })
        ).required().messages({
            'array.base': 'Integrantes debe ser un arreglo',
            'any.required': 'Debes agregar al menos un integrante'
        }),
        observaciones: Joi.string().min(5).max(120).allow(''),
        noReply: Joi.array().items(
            Joi.string().email({ minDomainSegments: 2, tlds: { allow: ['ar', 'com', 'net'] } })
        ),
        oficinas: Joi.array().items(Joi.number().min(1).max(9999).allow('')),
        internos: Joi.array().items(Joi.object({
            especificacion: Joi.string().min(3).max(120).allow('').messages({
                'string.min': 'Limite de especificacion',
                'string.max': 'Limite de especificacion'
            }),
            numero: Joi.number().integer().min(1).max(99999).allow('').messages({
                'number.base': 'Numero requerido',
                'number.min': 'Limite de numero',
                'number.max': 'Limite de numero',
            }),
        }).custom((area, helpers) => {
            if (area.numero === '' && area.especificacion !== '') {
                return helpers.error('any.required');
            }
            return area;
        })).allow(null),

    });

    const mensajeAlertaFalloFormulario = (fallo) => {
        if (fallo === "path") setMessage("Es obligatorio seterar la ruta del área");
        if (fallo === "nombre") setMessage("El nombre debe tener entre 3 y 150 caracteres");
        if (fallo === "integrantes") setMessage("El uid debe tener entre 3 y 70 caracteres");
        if (fallo === "observaciones") setMessage("Las observaciones deben tener entre 5 y 120 caracteres");
        if (fallo === "noReply") setMessage("Hay una dirección no-reply con formato inválido");
        if (fallo === "oficinas") setMessage("La oficina debe ser un numero de entre 1 y 4 digitos");
        if (fallo === "Numero requerido") { setMessage("Debe agregar un numero de interno") };
        if (fallo === "Limite de numero") { setMessage("Los numeros del interno debe ser un numero de entre 1 y 5 digitos.") };
        if (fallo === "Limite de especificacion") { setMessage("Las especificaciones del interno deben tener entre 3 y 20 caracteres") };
    }

    const onChange = (e) => {
        setArea({
            ...area,
            [e.target.name]: e.target.value
        });
    }

    const lista = (item, tipo) => (
        <Grid item xs={window.screen.width < SIZE_MD ? 12 : 6}>
            <Zoom in={true}>
                <ListItem
                    key={tipo}
                    secondaryAction={
                        <IconButton
                            edge="end"
                            aria-label="delete"
                            onClick={() => {
                                if (tipo === 'I') {// integrantes
                                    handleClickRemoveIntegrante(item)
                                }
                                else if (tipo === 'O') {// oficina
                                    handleClickRemoveOficina(item)
                                }
                                else if (tipo === 'T') {// interno
                                    handleClickRemoveInterno(item)
                                }
                            }}
                            size="large">
                            <RemoveIcon />
                        </IconButton>
                    }
                >
                    <ListItemText
                        primary={<div style={styleLista}>{
                            tipo === 'T' ?
                                item.especificacion !== '' ?
                                    item.numero + ' - ' + item.especificacion : item.numero
                                : item}</div>}
                    />
                </ListItem>
            </Zoom>
        </Grid>
    )

    const pathSUB = (bloqueadas, area) => {
        if (area.subRows && area.subRows.length > 0) {
            area.subRows.forEach((subArea) => {
                bloqueadas.push(subArea.path);
                pathSUB(bloqueadas, subArea);
            });
        }
        return bloqueadas;
    };


    const permitidas = (path, bloqueadas) => {
        let aux = true
        if (path === '/') return true
        bloqueadas.forEach((b) => {
            if (path.includes(b) && b !== '/') {
                aux = false
            }
        })
        return aux;
    }

    const filtrarAreasPosibles = () => {
        if (areas.length > 0 && areas[0]['path'] !== '/') { //como hago unshift me aseguro que el '/' va a etsr en el indicide 0
            areas.unshift({
                nombre: 'root',
                path: '/'
            })
        }

        let bloqueadas = [];
        bloqueadas.push(grupo.path);
        pathSUB(bloqueadas, grupo);

        let newAreas = [];
        newAreas = areasTreeFlatList.filter((a) => { return permitidas(a.path, bloqueadas) })
        return newAreas.map(a => <MenuItem key={a.nombre} value={a.path}> {a.path}</MenuItem>)
    }

    const cambiarNombre = () => {
        if (nombreAux !== '') {
            setArea({
                ...area,
                'nombre': nombreAux
            });
        } else {
            setMessage("No puede quedar el nombre vacio")
        }

    }

    const cambiarNombreAuxiliar = (target) => {
        setNombreAux(target.value);
    }

    return <>
        <Box mb={3}>
            <CloseButton onClose={onClose} />
            {loading ?
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
                    <CircularProgress color="secondary" />
                </div>
                :
                <Form onSubmit={handleSubmit}>
                    <Grid container>
                        <div style={{ margin: '3%' }}>
                            <div className={classes.iconos}>
                                {disabled ?
                                    <Tooltip title="Modificar nombre de la lista">
                                        <IconButton size="large">
                                            <EditIcon
                                                onClick={() => {
                                                    setDisabled(!disabled)
                                                    setDisabledSaveButton(true)
                                                }} />
                                        </IconButton>
                                    </Tooltip> : null}
                            </div>
                            <div style={{ alignItems: 'center' }}>
                                {disabled ? <Div>
                                    <Typography variant={matches ? "h5" : "h4"} gutterBottom component="div">
                                        {area.nombre}
                                    </Typography>
                                </Div> : null}
                            </div>
                            {!disabled ? //nombre del area
                                <div >
                                    <Input value={nombreAux}
                                        id="nombre-area"
                                        label="Nombre del área *"
                                        name="nombre"
                                        disabled={disabled}
                                        InputProps={{
                                            className: classes.disabled,
                                        }}
                                        onChange={(e) => cambiarNombreAuxiliar(e.target)}
                                        required
                                        placeholder={nombreAux}
                                        variant="outlined"
                                        margin="normal"
                                        endAdornment={disabled ? <InputAdornment position="end">
                                            <Tooltip title="Modificar nombre del área">
                                                <IconButton size="large">
                                                    <EditIcon
                                                        onClick={() => {
                                                            setDisabled(!disabled)
                                                            setDisabledSaveButton(true)
                                                        }} />
                                                </IconButton>
                                            </Tooltip>
                                        </InputAdornment> :
                                            <InputAdornment position="end">
                                                <Cruz onClick={(e) => {
                                                    setDisabled(!disabled)
                                                    setDisabledSaveButton(false)
                                                }} />
                                                <Check onClick={(e) => {
                                                    cambiarNombre()
                                                    setDisabled(!disabled);
                                                    setDisabledSaveButton(false);
                                                }} />
                                            </InputAdornment>
                                        }
                                    /></div> : null}
                        </div>
                        <Grid item xs={12} >
                            {/* {matches ? //subareas
                                            <div>
                                                <p className={classes.text}> Subáreas: </p>
                                                <TreeViewAreas padre={areaData} hijos={areaSub} propiedad={'S'} />
                                            </div>
                                            :
                                            <Grid container>
                                                <Grid item xs={2}>
                                                    <p className={classes.text}> Subáreas: </p>
                                                </Grid>
                                                <Grid item xs={10}>
                                                    <TreeViewAreas padre={areaData} hijos={areaSub} propiedad={'S'} />
                                                </Grid>
                                            </Grid>} */}

                            <ModalContent dividers>

                                <FormControl fullWidth>
                                    <TextFieldRojo
                                        id="select-path"
                                        label="Pertenece a"
                                        name="path"
                                        value={area.path}
                                        sx={{ my: 1 }}
                                        InputProps={{
                                            readOnly: true,
                                            disabled: true
                                        }}
                                        InputLabelProps={{
                                            classes: {
                                                root: classes.texto,
                                            },
                                        }} />

                                    {/* Comentado hasta que se actualize el manejo de subgrupos en el back, desde el front funciona bien pero falla la peticion.
                                            <InputLabel color="primary" id="select-path">Pertenece a: </InputLabel>
                                            <Select
                                                labelId="select-path"
                                                id="select-path-input"
                                                value={value.path}
                                                className={classes.select}
                                                name='path'
                                                label="Pertenece a *"
                                                color="primary"
                                                sx={{
                                                    border: '1px solid #ced4da', '&:focus': {
                                                        border: '0px'
                                                    },
                                                }}
                                                onChange={(e) => { onChange(e) }}
                                                InputLabelProps={{
                                                    classes: {
                                                        root: classes.texto,
                                                    },
                                                }}
                                            >
                                                {filtrarAreasPosibles() // por si quiere cambiar de ruta no puede cambiar a una que sea ella misma o sus hijos
                                            </Select>
                                            */}

                                    <FormInput
                                        label={"Ingrese Integrante"}
                                        fullWidth
                                        onKeyPress={(e) => { e.key === 'Enter' && handleClickAddIntegrante() }}
                                        onChange={handleChangeI()}
                                        value={integrantes}
                                        error={alert ? alert.status === 'error' : false}
                                        InputProps={{
                                            endAdornment:
                                                <InputAdornment position="end">
                                                    <IconButton onClick={() => handleClickAddIntegrante()} size="large">
                                                        <AddIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                        }}
                                        InputLabelProps={{
                                            classes: {
                                                root: classes.texto,
                                            },
                                        }}
                                    />
                                    {area.integrantes.map((i) => lista(i.username, 'I'))}
                                    <br /> <br />
                                    <AlertMessage alert={alertOficina} setAlert={setAlertOficina} />
                                    <FormInput
                                        variant="outlined"
                                        label={"Ingrese Numero de Oficina"}
                                        fullWidth
                                        onKeyPress={(e) => { e.key === 'Enter' && handleClickAddOficina() }}
                                        onChange={handleChangeO()}
                                        value={oficina}
                                        error={alert ? alert.status === 'error' : false}
                                        InputProps={{
                                            endAdornment:
                                                <InputAdornment position="end">
                                                    <IconButton onClick={() => handleClickAddOficina()} size="large">
                                                        <AddIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                        }}
                                        InputLabelProps={{
                                            classes: {
                                                root: classes.texto,
                                            },
                                        }}
                                    />
                                    {area.oficinas.map((i) => lista(i, 'O'))}
                                    <br /> <br />
                                    <AlertMessage alert={alertInterno} setAlert={setAlertInterno} />
                                    <Grid container spacing={2} sx={{ flexGrow: 1 }} >
                                        <Grid item xs={4}>
                                            <FormInput
                                                variant="outlined"
                                                label={"Ingrese Numero de Interno"}
                                                fullWidth
                                                onChange={handleChangeTN()}
                                                value={numero}
                                                error={alert ? alert.status === 'error' : false}
                                                InputLabelProps={{
                                                    classes: {
                                                        root: classes.texto,
                                                    },
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={8}>
                                            <FormInput
                                                variant="outlined"
                                                label={"Ingrese Especificación"}
                                                fullWidth
                                                onKeyPress={(e) => { e.key === 'Enter' && handleClickAddInterno() }}
                                                onChange={handleChangeTD()}
                                                value={especificacion}
                                                error={alert ? alert.status === 'error' : false}
                                                InputProps={{
                                                    endAdornment:
                                                        <InputAdornment position="end">
                                                            <IconButton onClick={() => handleClickAddInterno()} size="large">
                                                                <AddIcon />
                                                            </IconButton>
                                                        </InputAdornment>
                                                }}
                                                InputLabelProps={{
                                                    classes: {
                                                        root: classes.texto,
                                                    },
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                    {area.internos.map((i) => lista(i, 'T'))}
                                    <FormInputMultiline
                                        name="observaciones"
                                        label="Observaciones"
                                        value={area.observaciones}
                                        className={classes.input}
                                        onChange={(e) => { onChange(e) }}
                                        onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                        fullWidth
                                        InputLabelProps={{
                                            classes: {
                                                root: classes.texto,
                                            },
                                        }}
                                    />
                                    <br /> <br />
                                    <CamposNoReply
                                        className={classes.input}
                                        direcciones={area.noReply ?? []}
                                        onChange={(direcciones) => setArea({ ...area, noReply: direcciones })}
                                    />

                                </FormControl>
                            </ModalContent>

                        </Grid>

                    </Grid>
                    <ModalActions>
                        <SaveButton label={"Confirmar cambios"} onClick={handleSubmit} type="button" />
                    </ModalActions>
                </Form>}
            <ConfirmarNoReplyDuplicado
                conflicto={conflictoNoReply}
                loading={loading}
                onCancelar={() => setConflictoNoReply(null)}
                onConfirmar={() => editarArea(conflictoNoReply.body, true)}
            />
        </Box>
    </>;
}